import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8f93eac"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "is-flex is-justify-content-center mb-2 mt-2"
}

import { computed, defineAsyncComponent, ref, watch } from 'vue'
import { Scrollbar } from 'smooth-scrollbar/interfaces'

import { useAppStore } from '@/popup/store/AppStore'
import Scroll from '@/popup/components/shared/Scroll/Scroll.vue'
import { useUIStore } from '@/popup/store/UIStore'
import { useApprovalsStore } from '@/popup/store/ApprovalsStore'
import Button from '@/popup/components/shared/Button.vue'
import {
  ContractCreateComponent,
  Transaction,
} from '@/shared/models/Transaction'
import { useGlobals } from '@/popup/compositions/useGlobals'
import { InternalMethods } from '@/shared/apis/messages'
import { Activity, ActivityModelVariants } from '@/shared/models/Activity'
import { ApprovalApi } from '@/shared/apis/approvals'


export default /*#__PURE__*/_defineComponent({
  __name: 'Activity',
  setup(__props) {

const appStore = useAppStore()
const approvalsStore = useApprovalsStore()
const uiStore = useUIStore()
const hasReachedProfileCreated = ref(false)
const fetchBtnDisabled = ref(false)
const displayedActivities = ref<Activity<ActivityModelVariants>[]>([])

const sort = (activities: Activity<ActivityModelVariants>[]) => {
  return activities.sort((a, b) => {
    if (!a.createdAt || !b.createdAt) {
      return 0
    }

    if (a.createdAt > b.createdAt) {
      return -1
    } else if (a.createdAt < b.createdAt) {
      return 1
    } else {
      return 0
    }
  })
}

const checkIfProfileCreatedEventIsVisible = (transaction: Transaction) => {
  const components = transaction.components
  if (
    components &&
    components.length > 0 &&
    components[0].component === ContractCreateComponent.component
  ) {
    hasReachedProfileCreated.value = true
  }
}

const activities = computed(() => {
  let activityApprovals: Activity<ActivityModelVariants>[] = []
  let activityCompleted: Activity<ActivityModelVariants>[] = []

  for (const approval of approvalsStore.profileApprovals) {
    activityApprovals.push({
      createdAt: approval.time,
      type: approval.type,
      details: approval.requestData as ActivityModelVariants,
      isApproval: true,
      id: approval.id,
    })
  }

  for (const transaction of appStore.transactions) {
    checkIfProfileCreatedEventIsVisible(transaction)
    activityCompleted.push({
      createdAt: transaction.createdAt,
      type: 'transaction',
      details: transaction,
      isApproval: false,
      id: transaction.requestId,
    })
  }

  return [
    ...sort(activityApprovals),
    ...sort(activityCompleted).slice(0, appStore.fetchCount),
  ]
})

const showActivities = computed(
  () => uiStore.currentTab === 'ACTIVITY' && activities.value.length > 0
)

watch(
  () => appStore.transactions,
  () => {
    const txCount = appStore.transactions.length
    if (txCount > 0) {
      checkIfProfileCreatedEventIsVisible(appStore.transactions[0])
    }
  }
)

watch(activities, () => {
  if (activities.value.length > displayedActivities.value.length) {
    fetchBtnDisabled.value = false
  }
})

const loadActivities = () => {
  displayedActivities.value = activities.value
  fetchBtnDisabled.value = true
}

const onBeforeUnmount = (scrollInstance: Scrollbar) => {
  uiStore.scrollPosition.activityView = scrollInstance.scrollTop || 0
}

const getNextTransactions = async () => {
  appStore.fetchCount *= 2
  await fetchMore()
}

const activityComponents: { [T in keyof ApprovalApi]: any } = {
  transaction: defineAsyncComponent(
    () =>
      import(
        `@/popup/components/views/Home/Profile/Activities/TransactionActivity.vue`
      )
  ),
  sign: undefined,
  requestAccounts: undefined,
  relayer: undefined,
  import: undefined,
  addNetwork: undefined,
  switchNetwork: undefined,
  createAddress: undefined,
}

const fetchMore = async () => {
  await useGlobals().sendMessage({
    method: InternalMethods.FETCH_PROFILE_EVENTS,
    payload: { address: appStore.currentProfile.address },
  })
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(Scroll, {
    class: "p-4",
    "y-position": _unref(uiStore).scrollPosition.activityView,
    "update-on": _unref(uiStore).scrollRefresh,
    "on-before-unmount": onBeforeUnmount,
    onOnBottomScroll: getNextTransactions
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activities.value, (activity) => {
        return (_openBlock(), _createElementBlock("div", {
          key: activity.id
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(activityComponents[activity.type]), { activity: activity }, null, 8 /* PROPS */, ["activity"]))
        ]))
      }), 128 /* KEYED_FRAGMENT */)),
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          (!fetchBtnDisabled.value && !hasReachedProfileCreated.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Button, {
                  class: "mb-4",
                  variant: "secondary",
                  size: "small",
                  "custom-class": "paragraph-inter-12-semi-bold",
                  onClick: loadActivities
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('profile.activity.load_more')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["y-position", "update-on"])), [
    [_vShow, showActivities.value]
  ])
}
}

})